import "./tabsStyles.css";
import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";

export default function AlertsTab({ alerts }: any) {
  const [ok, setOk] = useState(false);

  useEffect(() => {
    if (alerts !== undefined) {
      setOk(true);
    }
    if (alerts.length === 0) {
      setOk(false);
    }
  }, [alerts]);

  return (
    <div className="make-visible">
      <h2>Alerts</h2>
      {ok ? (
        <div>
          {alerts.map((item: any) => {
            return (
              <div className="alert-div" key={item}>
                <a href={item.uri} className="alert-deco">
                  <div className="clean-box">
                    <h4 style={{ fontWeight: "bolder" }}> {item.headline}</h4>
                    <hr />
                    <p>
                      From : {item.effective} <br /> To : {item.expires}
                      <br />
                      Note: {item.note}
                    </p>
                    <hr />
                    <p>{item.desc}</p>
                    <hr />
                    <p>
                      INSTRUCTIONS <br /> {item.instruction}
                    </p>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      ) : (
        <Row>
          <Col>
            <h4>There are no Alert for your location.</h4>{" "}
          </Col>
          <Col>
            {" "}
            <i className="fa fa-bell-slash fa-5x"></i>{" "}
          </Col>
        </Row>
      )}
      <br />
    </div>
  );
}
